module.exports = __webpack_public_path__ + "img/valet-julie.6e3063f2.jpeg";